<template>
    <v-dialog v-model="internalDialog" fullscreen max-width="100%">
        <template v-slot:activator="{ on, attrs }">
            <slot name="activator" :on="on" :attrs="attrs">
                <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" fab>
                    <v-icon>mdi-plus</v-icon>
                </v-btn>
            </slot>
        </template>
        <v-card>
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="handleClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>{{ title }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark text @click="handleSave" :disabled="disableSave">
                        {{ saveText }}
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-card-text>
                <v-container style="margin-top: 10px;">
                    <v-form ref="formMensagem" v-model="internalFormValid">
                        <v-row justify="start" v-if="templates.length > 0">
                            <v-col cols="12">
                                <v-alert 
                                    v-if="!whatsappDisponivel"
                                    type="warning"
                                    dense
                                    outlined
                                    text
                                >
                                    <v-icon small color="orange" class="mr-2">mdi-alert</v-icon>
                                    {{ whatsappUnavailableMessage }}
                                </v-alert>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-switch
                                    v-model="useTemplate"
                                    color="primary"
                                    :label="useTemplateLabel"
                                    :disabled="disableFields || !whatsappDisponivel"
                                ></v-switch>
                            </v-col>
                            <v-col cols="12" sm="6" v-if="useTemplate">
                                <v-autocomplete
                                    v-model="selectedTemplate"
                                    :items="filteredTemplates"
                                    :item-text="getTemplateText"
                                    item-value="id_template"
                                    :label="templateLabel"
                                    clearable
                                    outlined
                                    dense
                                    prepend-inner-icon="mdi-file-document-outline"
                                    :disabled="disableFields"
                                    @change="handleTemplateSelection"
                                >
                                    <template v-slot:item="{ item }">
                                        <v-list-item-content>
                                            <v-list-item-title>{{ item.titulo || item.descricao }}</v-list-item-title>
                                            <v-list-item-subtitle v-if="item.cod_template">
                                                {{ codeText }}: {{ item.cod_template }}
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                    </template>
                                    <template v-slot:selection="{ item }">
                                        {{ item.titulo || item.descricao }}
                                    </template>
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col cols="12" sm="10">
                                <v-text-field 
                                    :value="editedItem.titulo" 
                                    @input="updateField('titulo', $event)"
                                    :label="titleLabel"
                                    clearable 
                                    solo
                                    :disabled="disableFields || useTemplate"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="2">
                                <v-switch 
                                    v-model="automaticaLocal"
                                    color="primary"
                                    :label="automaticLabel"
                                ></v-switch>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col cols="12" sm="10">
                                <v-textarea 
                                    :value="editedItem.descricao"
                                    @input="updateField('descricao', $event)"
                                    :label="headerLabel" 
                                    auto-grow 
                                    clearable
                                    :disabled="disableFields || useTemplate"
                                ></v-textarea>
                            </v-col>
                        </v-row>
                        <v-row justify="start" v-if="computedVariaveisDescription.length > 0">
                            <v-col cols="12" sm="3" v-for="(variavel, index) in computedVariaveisDescription" :key="variavel.id">
                                <v-text-field
                                    :value="variavel.value"
                                    @input="updateVariavelDescricao(index, $event)"
                                    :label="variableText + ' ' + variavel.key.replace(/\D/g, '')"
                                    outlined
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col cols="12" sm="10">
                                <v-textarea 
                                    :value="editedItem.corpo"
                                    @input="updateField('corpo', $event)"
                                    :label="bodyLabel" 
                                    auto-grow 
                                    clearable
                                    counter 
                                    :disabled="disableFields || useTemplate"
                                ></v-textarea>
                            </v-col>
                        </v-row>
                        <v-row justify="start" v-if="computedVariaveisBody.length > 0">
                            <v-col cols="12" sm="3" v-for="(variavel, index) in computedVariaveisBody" :key="variavel.id">
                                <v-text-field
                                    :value="variavel.value"
                                    @input="updateVariavelCorpo(index, $event)"
                                    :label="variableText + ' ' + variavel.key.replace(/\D/g, '')"
                                    outlined
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col cols="12" sm="10">
                                <v-textarea 
                                    :value="editedItem.rodape"
                                    @input="updateField('rodape', $event)"
                                    :label="footerLabel" 
                                    auto-grow 
                                    clearable
                                    :disabled="disableFields || useTemplate"
                                    :hint="footerHint"
                                    counter="60"
                                    maxlength="60"
                                ></v-textarea>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
                
                <merus-data-table 
                    :headers="headersEnvio" 
                    :items="enviosMensagem"
                    :loading="loadingEnviosMensagem" 
                    :default-multi-sort="defaultSortEnvio"
                    :loading-text="loadingText"
                    @update:displayedItems="displayedItemsForExportEnvios = $event"
                >
                    <template v-slot:toolbar>
                        <CadastroToolbar 
                            :title="deliveryTitle" 
                            :token="token"
                            :items="displayedItemsForExportEnvios !== null ? displayedItemsForExportEnvios : enviosMensagem" 
                            csv-title="enviosmensagem"
                            :csv-headers="headersEnvio"
                            :pdf-title="deliveryTitle" 
                            :pdf-headers="headersEnvio"
                            pdf-filename="enviosmensagem" 
                            hide-search
                        ></CadastroToolbar>
                    </template>
                </merus-data-table>

                <merus-data-table
                    :headers="headersPublicacao"
                    :items="publicacoesMensagem"
                    :loading="loadingPublicacoesMensagem"
                    :default-multi-sort="defaultSortPublicacao"
                    :loading-text="loadingText"
                    @update:displayedItems="displayedItemsForExportPublicacoes = $event"
                >
                    <template v-slot:toolbar>
                        <CadastroToolbar
                            :title="publishesTitle"
                            :token="token"
                            :items="displayedItemsForExportPublicacoes !== null ? displayedItemsForExportPublicacoes : publicacoesMensagem"
                            csv-title="publicacoesmensagem"
                            :csv-headers="headersPublicacao"
                            :pdf-title="publishesTitle"
                            :pdf-headers="headersPublicacao"
                            pdf-filename="publicacoesmensagem"
                            hide-search
                        ></CadastroToolbar>
                    </template>

                    <template v-slot:item.actions="{ item }">
                        <v-icon 
                            small 
                            class="mr-2" 
                            :color="canEditPublicacao(item) ? 'green' : 'grey'" 
                            @click="canEditPublicacao(item) ? handleEditPublicacao(item) : null"
                            :disabled="!canEditPublicacao(item)"
                        >mdi-pencil</v-icon>
                        <v-icon 
                            small 
                            class="mr-2" 
                            :color="canDeletePublicacao(item) ? 'red' : 'grey'" 
                            @click="canDeletePublicacao(item) ? handleDeletePublicacao(item) : null"
                            :disabled="!canDeletePublicacao(item)"
                        >mdi-delete</v-icon>
                    </template>
                </merus-data-table>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import MerusDataTable from '../Tables/MerusDataTable.vue';
import CadastroToolbar from '../Toolbars/CadastroToolbar.vue';

export default {
    name: 'EditMensagemDialog',
    components: {
        MerusDataTable,
        CadastroToolbar
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: 'Mensagem'
        },
        editedItem: {
            type: Object,
            default: () => ({
                titulo: null,
                descricao: null,
                corpo: null,
                rodape: null,
                automatica: false,
                enviada: 0
            })
        },
        enviosMensagem: {
            type: Array,
            default: () => []
        },
        publicacoesMensagem: {
            type: Array,
            default: () => []
        },
        headersEnvio: {
            type: Array,
            default: () => []
        },
        headersPublicacao: {
            type: Array,
            default: () => []
        },
        defaultSortEnvio: {
            type: Array,
            default: () => []
        },
        defaultSortPublicacao: {
            type: Array,
            default: () => []
        },
        loadingEnviosMensagem: {
            type: Boolean,
            default: false
        },
        loadingPublicacoesMensagem: {
            type: Boolean,
            default: false
        },
        token: {
            type: String,
            default: ''
        },
        titleLabel: {
            type: String,
            default: 'Título'
        },
        headerLabel: {
            type: String,
            default: 'Cabeçalho'
        },
        variavelDescription: {
            type: Array,
            default: () => []
        },
        variaveisBody: {
            type: Array,
            default: () => []
        },
        variableText: {
            type: String,
            default: 'Variável'
        },
        bodyLabel: {
            type: String,
            default: 'Mensagem'
        },
        footerLabel: {
            type: String,
            default: 'Rodapé'
        },
        automaticLabel: {
            type: String,
            default: 'Automática'
        },
        footerHint: {
            type: String,
            default: 'Texto opcional (máx. 200 caracteres)'
        },
        deliveryTitle: {
            type: String,
            default: 'Envios'
        },
        publishesTitle: {
            type: String,
            default: 'Publicações'
        },
        loadingText: {
            type: String,
            default: 'Carregando...'
        },
        saveText: {
            type: String,
            default: 'Salvar'
        },
        templateLabel: {
            type: String,
            default: 'Selecionar Template'
        },
        useTemplateLabel: {
            type: String,
            default: 'Usar Template'
        },
        codeText: {
            type: String,
            default: 'Código'
        },
        templates: {
            type: Array,
            default: () => []
        },
        formValid: {
            type: Boolean,
            default: false
        },
        whatsappDisponivel: {
            type: Boolean,
            default: true
        },
        whatsappUnavailableMessage: {
            type: String,
            default: 'Templates não podem ser usados pois o WhatsApp não está configurado.'
        },
        templateWithoutName: {
            type: String,
            default: 'Template sem nome'
        }
    },
    data() {
        return {
            selectedTemplate: null,
            useTemplate: false,
            variaveisDescricaoLocal: [],
            variaveisCorpoLocal: [],
            displayedItemsForExportEnvios: null,
            displayedItemsForExportPublicacoes: null
        }
    },
    computed: {
        internalDialog: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        },
        internalFormValid: {
            get() {
                return this.formValid;
            },
            set(value) {
                this.$emit('update:formValid', value);
            }
        },
        automaticaLocal: {
            get() {
                // Retorna boolean (true/false) para o v-switch
                return this.editedItem.automatica == 1 || this.editedItem.automatica === true;
            },
            set(value) {
                // Atualiza o editedItem quando o switch muda
                this.updateField('automatica', value);
            }
        },
        disableFields() {
            return this.editedItem.enviada == 1;
        },
        disableSave() {
            return this.editedItem.enviada == 1;
        },
        filteredTemplates() {
            // Filtrar apenas templates locais (sem id_template_meta) ou templates aprovados pela Meta da categoria UTILITY
            return this.templates.filter(template => 
                !template.id_template_meta || (template.status === 'APPROVED' &&  template.categoria === 'UTILITY') 
            );
        },
        computedVariaveisDescription() {
            return this.variaveisDescricaoLocal;
        },
        computedVariaveisBody() {
            return this.variaveisCorpoLocal;
        }
    },
    methods: {
        updateField(field, value) {
            const updated = { ...this.editedItem, [field]: value };
            this.$emit('update:editedItem', updated);
        },
        updateVariavelDescricao(index, value) {
            // Usa Vue.set para garantir reatividade
            this.$set(this.variaveisDescricaoLocal[index], 'value', value);
        },
        updateVariavelCorpo(index, value) {
            // Usa Vue.set para garantir reatividade
            this.$set(this.variaveisCorpoLocal[index], 'value', value);
        },
        handleClose() {
            this.$emit('close');
        },
        handleSave() {
            // Sincronizar variáveis antes de salvar
            const camposDescricao = this.variaveisDescricaoLocal.length > 0 
                ? JSON.stringify(this.variaveisDescricaoLocal) 
                : null;
            const camposCorpo = this.variaveisCorpoLocal.length > 0 
                ? JSON.stringify(this.variaveisCorpoLocal) 
                : null;
                   
            // Atualizar o editedItem diretamente
            const updated = { 
                ...this.editedItem, 
                campos_descricao: camposDescricao,
                campos_corpo: camposCorpo
            };
            
            // Emitir a atualização
            this.$emit('update:editedItem', updated);
            
            // Aguardar o próximo tick para garantir que o pai recebeu a atualização
            this.$nextTick(() => {
                this.$emit('save');
            });
        },
        extractVariaveisFromText(text, prefix) {
            if (!text) return [];
            
            const regex = /\{\{(\d+)\}\}/g;
            const matches = [];
            let match;
            
            while ((match = regex.exec(text)) !== null) {
                const num = match[1];
                if (!matches.find(m => m.key === `{{${num}}}`)) {
                    matches.push({
                        id: `${prefix}_var_${num}`,
                        key: `{{${num}}}`,
                        value: ''
                    });
                }
            }
            
            return matches.sort((a, b) => {
                const numA = parseInt(a.key.replace(/\D/g, ''));
                const numB = parseInt(b.key.replace(/\D/g, ''));
                return numA - numB;
            });
        },
        initializeVariaveis() {
            // Inicializar variáveis de descrição
            let descVars = this.extractVariaveisFromText(this.editedItem.descricao, 'desc');
            
            // Se existem valores salvos em campos_descricao, usá-los
            if (this.editedItem.campos_descricao) {
                try {
                    const savedDescVars = typeof this.editedItem.campos_descricao === 'string' 
                        ? JSON.parse(this.editedItem.campos_descricao) 
                        : this.editedItem.campos_descricao;
                    
                    if (Array.isArray(savedDescVars)) {
                        descVars = descVars.map(v => {
                            const saved = savedDescVars.find(s => s.key === v.key);
                            return saved ? { ...v, value: saved.value } : v;
                        });
                    }
                } catch (e) {
                    console.error('Erro ao parsear campos_descricao:', e);
                }
            }
            this.variaveisDescricaoLocal = descVars;
            
            // Inicializar variáveis de corpo
            let bodyVars = this.extractVariaveisFromText(this.editedItem.corpo, 'body');
            
            // Se existem valores salvos em campos_corpo, usá-los
            if (this.editedItem.campos_corpo) {
                try {
                    const savedBodyVars = typeof this.editedItem.campos_corpo === 'string' 
                        ? JSON.parse(this.editedItem.campos_corpo) 
                        : this.editedItem.campos_corpo;
                    
                    if (Array.isArray(savedBodyVars)) {
                        bodyVars = bodyVars.map(v => {
                            const saved = savedBodyVars.find(s => s.key === v.key);
                            return saved ? { ...v, value: saved.value } : v;
                        });
                    }
                } catch (e) {
                    console.error('Erro ao parsear campos_corpo:', e);
                }
            }
            this.variaveisCorpoLocal = bodyVars;
        },
        handleEditPublicacao(item) {
            this.$emit('edit-publicacao', item);
        },
        handleDeletePublicacao(item) {
            this.$emit('delete-publicacao', item);
        },
        canEditPublicacao(publicacao) {
            // Só pode editar publicações cuja vigência ainda não terminou
            if (!publicacao.dt_fim_vigencia) {
                return true;
            }
            const dtFim = new Date(publicacao.dt_fim_vigencia);
            const agora = new Date();
            return dtFim >= agora;
        },
        canDeletePublicacao(publicacao) {
            // Não pode deletar publicações que já estão vigentes
            const dtInicio = new Date(publicacao.dt_inicio_vigencia);
            const agora = new Date();
            return dtInicio > agora;
        },
        getTemplateText(item) {
            return item.titulo || item.descricao || item.cod_template || this.templateWithoutName;
        },
        handleTemplateSelection(templateId) {
            if (!templateId) {
                this.selectedTemplate = null;
                return;
            }
            
            const template = this.templates.find(t => t.id_template === templateId);
            if (template) {
                this.$emit('template-selected', template);          
            }
        },
        validate() {
            return this.$refs.formMensagem.validate();
        },
        resetValidation() {
            if (this.$refs.formMensagem) {
                this.$refs.formMensagem.resetValidation();
            }
        },
        checkIfMessageIsTemplate() {
            // Verifica se a mensagem atual corresponde a algum template
            if (!this.editedItem || !this.templates || this.templates.length === 0) {
                this.useTemplate = false;
                this.selectedTemplate = null;
                return;
            }

            // Procura template que corresponda à mensagem atual
            const matchingTemplate = this.templates.find(t => {
                // Verifica se todos os campos principais são iguais
                return (t.titulo === this.editedItem.titulo || (!t.titulo && !this.editedItem.titulo)) &&
                       (t.descricao === this.editedItem.descricao || (!t.descricao && !this.editedItem.descricao)) &&
                       (t.corpo === this.editedItem.corpo || (!t.corpo && !this.editedItem.corpo)) &&
                       (t.rodape === this.editedItem.rodape || (!t.rodape && !this.editedItem.rodape));
            });

            if (matchingTemplate) {
                this.useTemplate = true;
                this.selectedTemplate = matchingTemplate.id_template;
            } else {
                this.useTemplate = false;
                this.selectedTemplate = null;
            }
        },
        clearMessageFields() {
            // Limpa todos os campos da mensagem de uma vez
            const updated = {
                ...this.editedItem,
                titulo: '',
                descricao: '',
                campos_descricao: null,
                corpo: '',
                campos_corpo: null,
                rodape: ''
            };
            
            // Limpar arrays locais de variáveis
            this.variaveisDescricaoLocal = [];
            this.variaveisCorpoLocal = [];
            
            this.$emit('update:editedItem', updated);
        }
    },
    watch: {
        value(newVal) {
            // Quando o dialog for aberto, verifica se a mensagem corresponde a um template
            if (newVal) {
                this.checkIfMessageIsTemplate();
                this.initializeVariaveis();
            }
        },
        useTemplate(newVal, oldVal) {
            if (oldVal === true && newVal === false) {
                this.selectedTemplate = null;
                // Limpa imediatamente
                this.clearMessageFields();
            }
        },
        selectedTemplate(newVal) {
            // Quando o template selecionado for limpo manualmente, também limpa os campos
            if (newVal === null && this.useTemplate) {
                this.clearMessageFields();
            }
        },
        'editedItem.descricao': {
            handler() {
                // Atualiza variáveis quando o texto da descrição muda
                const newVars = this.extractVariaveisFromText(this.editedItem.descricao, 'desc');
                // Preservar valores já preenchidos
                this.variaveisDescricaoLocal = newVars.map(v => {
                    const existing = this.variaveisDescricaoLocal.find(e => e.key === v.key);
                    return existing ? { ...v, value: existing.value } : v;
                });
            }
        },
        'editedItem.corpo': {
            handler() {
                // Atualiza variáveis quando o texto do corpo muda
                const newVars = this.extractVariaveisFromText(this.editedItem.corpo, 'body');
                // Preservar valores já preenchidos
                this.variaveisCorpoLocal = newVars.map(v => {
                    const existing = this.variaveisCorpoLocal.find(e => e.key === v.key);
                    return existing ? { ...v, value: existing.value } : v;
                });
            }
        },
        'editedItem.campos_descricao': {
            handler(newVal, oldVal) {
                // Quando campos_descricao mudar (ex: ao aplicar template), reinicializar
                // Só reinicializa se o valor realmente mudou externamente
                if (newVal !== oldVal && this.editedItem.campos_descricao) {
                    const newValsString = JSON.stringify(newVal);
                    const localValsString = this.variaveisDescricaoLocal.length > 0 
                        ? JSON.stringify(this.variaveisDescricaoLocal) 
                        : null;
                    
                    // Só reinicializa se não for uma mudança que veio do próprio componente
                    if (newValsString !== localValsString) {
                        this.initializeVariaveis();
                    }
                }
            }
        },
        'editedItem.campos_corpo': {
            handler(newVal, oldVal) {
                // Quando campos_corpo mudar (ex: ao aplicar template), reinicializar
                // Só reinicializa se o valor realmente mudou externamente
                if (newVal !== oldVal && this.editedItem.campos_corpo) {
                    const newValsString = JSON.stringify(newVal);
                    const localValsString = this.variaveisCorpoLocal.length > 0 
                        ? JSON.stringify(this.variaveisCorpoLocal) 
                        : null;
                    
                    // Só reinicializa se não for uma mudança que veio do próprio componente
                    if (newValsString !== localValsString) {
                        this.initializeVariaveis();
                    }
                }
            }
        }
    }
}
</script>

